import styled from 'styled-components';
import { customMedia } from 'styles/utils';

import Button from 'components/Button';
import Heading from 'components/Heading';
import Input from 'components/Form/Input';

import { Avatar } from 'components';

import { PinConfig } from 'libs/rendering/gltf/config';
import { themes } from 'styles/themes/wikifactoryNew';

export const PinListStyled = styled.div`
  position: absolute;
  top: ${props => props.top}px;
`;

export const PinDialog = styled.div.attrs(props => ({
  style: {
    left: props.left,
    top: props.top,
    display: props.visible ? 'block' : 'none',
  },
}))`
  pointer-events: all;
  z-index: 1010;
  position: absolute;
  padding: 0;
  margin: 0;
`;

export const PinStyled = styled.div.attrs(props => ({
  style: {
    left: props.left,
    top: props.top,
    display: props.visible ? 'block' : 'none',
  },
}))`
  pointer-events: all;
  z-index: 1004;
  position: absolute;
  padding: 0;
  margin: 0;
  &:hover {
    cursor: pointer;
    opacity: 1;
  }
`;

export const ButtonStyled = styled(Button)`
  padding: 0;
  margin: 0;
  transition: all 0s;
  svg {
    path {
      fill-rule: inherit;
      fill: ${props =>
        props.hovered ? themes.color.wfGrey200 : themes.color.wfWhite};
      stroke: ${props =>
        props.hovered ? themes.color.wfBlue : themes.color.wfBlack};
    }
  }
  &:hover {
    svg {
      path {
        stroke: ${props =>
          props.shared ? themes.color.wfBlue : themes.color.wfGrey200};
      }
    }
  }
`;

// dialog
export const DialogStyled = styled.article`
  position: absolute;
  background-color: white;
  width: ${props => `${props.width}px`};
  left: ${props => `${props.left}px`};
  top: 0;
  border: 1px solid ${themes.color.wfGrey350};
  display: ${props => (props.visible ? 'block' : 'none')};
  max-height: 300px;
  overflow-x: scroll;

  &:after {
    content: '';
    position: absolute;
    top: ${0.5 * PinConfig.pinSize - PinConfig.pinDialogOffset}px;
    left: ${props => props.left > 0 && '0'};
    right: ${props => props.left < 0 && '0'};
    margin-left: ${props =>
      props.left > 0 && `${-PinConfig.pinDialogOffset}px`};
    margin-right: ${props =>
      props.left < 0 && `${-PinConfig.pinDialogOffset}px`};
    width: 0;
    height: 0;
    border-style: solid;
    transform: ${props =>
      props.left > 0 ? 'rotate(-45deg)' : 'rotate(135deg)'};
    border-width: ${2 * PinConfig.pinDialogOffset}px
      ${2 * PinConfig.pinDialogOffset}px 0 0;
    border-color: ${props => props.theme.color.wfWhite} transparent transparent
      transparent;
  }
`;

export const PinMessageStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${props => props.theme.spacing.small};
  float: right;
`;

export const ButtonNoteHeader = styled(Button)`
  margin: 0;
  padding: 0;
  vertical-align: top;
  &:hover {
    color: #ff4d00;
  }
`;

export const TextInputStyled = styled.div`
  position: relative;
  padding: ${props => props.theme.spacing.small};
  padding-bottom: ${props => props.theme.spacing.medium};
  width: calc(100% - 20px);
  ${props =>
    props.isGhost &&
    `
    border-radius: 0;
    border-color: transparent !important;
    &:focus {
      border-color: transparent !important;
    }
    &:active {
      border-color: transparent !important;
    }
    `};
  /* FIXME: Remove once new them in new-brand branch could be merged */
  /* > input {
    border-color: ${props => props.theme.color.wfGrey200};
  } */
`;

export const InputStyled = styled(Input)`
  border-color: ${props =>
    props.isGhost ? 'transparent' : props.theme.color.wfGrey200};
  border-radius: ${props =>
    props.isGhost ? '0' : props.theme.borderRadius.large};
  ${props =>
    props.isGhost &&
    `
    padding: 0;
    border-radius: 0;
    border-color: transparent !important;
    &:focus {
      border-color: transparent !important;
    }
    &:active {
      border-color: transparent !important;
    }
    `}
`;

export const NoteButtons = styled.div`
  text-align: right;
  padding: ${props => props.theme.spacing.small};
`;

export const ButtonNoteInput = styled(Button)`
  color: white;
  &:not(:first-of-type) {
    margin-left: ${props => props.theme.spacing.xsmall};
  }
`;

export const DialogHeader = styled.header`
  display: flex;
  align-items: center;
  padding: 0 ${props => props.theme.spacing.small};
`;

export const AvatarStyled = styled(Avatar)`
  width: 30px;
  height: 30px;
`;

export const SenderName = styled(Heading)`
  margin: 0 ${props => props.theme.spacing.default};
  color: black;
`;

export const ButtonSend = styled(Button)`
  color: #c8c8c8;
  position: absolute;
  right: 12px;
  top: 12px;

  ${customMedia.lessThan('medium')`
    right: 10px;
    top: 10px;
  `}
`;

export const DialogButtons = styled.nav`
  margin-left: auto;
  button {
    margin-left: ${props => props.theme.spacing.default};
  }
`;

export const DialogMessage = styled.div`
  margin-top: ${props => props.theme.spacing.small};
  font-size: ${props => props.theme.font.size.xsmall};
  padding-left: ${props => props.theme.spacing.xlarge};
  height: 80px;
  overflow-y: auto;
`;

export const DialogFooter = styled.footer`
  border-top: 1px solid ${props => props.theme.color.wfGrey200};
  margin: 0 -${props => props.theme.spacing.small};
  padding: ${props =>
    `${props.theme.spacing.small} ${props.theme.spacing.small} 0`};
  position: relative;
`;
